import React from 'react';
import { Trans } from 'react-i18next';
import { Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const CheckFlowHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="check_flow" t={t}>
      <Box mt={4} mb={2}>
        <Subtitle>
          Die Art Ihres Mietverhältnisses ist für den Prüfprozess wichtig, da bei Abrechnungen für Gewerberäumlichkeiten
          oft Positionen vorkommen, die bei einem normalen Mietverhältnis nicht anfallen. So dürfen beispielsweise
          Verwaltungskosten nicht auf normale Mieter umgelegt werden, während dies in einem Gewerbemietverhältnis
          erlaubt ist.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Des Weiteren müssen speziell in Gewerbemietverträgen anfallende Nebenkosten spezifisch im Mietvertrag als
          umlagefähig definiert werden, sonst sind sie ungültig.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Hat Ihr Vermieter korrekt abgerechnet ausschließlich die vereinbarten Kosten auf Sie umgelegt?
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default CheckFlowHelp;
